import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import App from './App';
import store from './store';
import {boot} from './actions';
import config from './config';

ReactDOM.render(
  <App />, 
  document.getElementById('root')
);

store.dispatch(boot(config.gapi));


// WEBPACK FOOTER //
// ./src/index.js